import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RefusedEffects, refusedReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([RefusedEffects]), StoreModule.forFeature(`refused`, refusedReducer)]
})
export class RefusedStateModule {}
